import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Modal, Spinner } from "react-bootstrap";
import Select from "react-select"
import SweetAlert from "react-bootstrap-sweetalert"
import { get, isEmpty } from "lodash"
import { getBaseUrl } from "../../../reducers";
import { getProduct } from "../../../../../requesters/productRequester"
import { updateJobServiceProduct } from "../../../../../requesters/jobServiceRequester"

const UpdateJobServiceCodeModal = ({
  show, onHide, reloadData, jobService
}) => {
  const {
    id: jobServiceId,
    attributes: { label }
  } = jobService
  const baseUrl = useSelector(getBaseUrl)
  const [productCodeOptions, setProductCodeOptions] = useState([])
  const [requesting, setRequesting] = useState(false)
  const [showConfirmation, setShowConfirmation] = useState(false)
  const [currentReason, setCurrentReason] = useState("")
  const [newProduct, setNewProduct] = useState({})

  const onClearStates = () => {
    setNewProduct({})
    setCurrentReason("")
  }

  const onConfirm = () => {
    if (requesting) return;

    setShowConfirmation(false)
    setRequesting(true)
    updateJobServiceProduct(baseUrl, jobServiceId, { product_id: newProduct?.value, reason: currentReason })
    .then(res => {
      if (res.status === 200 && res.response.success) {
        reloadData()
        onHide()
        onClearStates()
      }
    })
    .catch(err => console.log(err))
    .finally(() => setRequesting(false))
  }

  const fetchProducts = () => {
    getProduct(baseUrl)
    .then(res => {
      if (res.status === 200) {
        const products = Object.values(get(res.response, "product", {})) ?? []
        const jobServiceOptions = products.map(p => ({ label: p.attributes.name, value: p.id }))
        setProductCodeOptions(jobServiceOptions)
      }
    })
    .catch(err => console.log(err))
  }

  useEffect(() => {
    fetchProducts()
  }, [])

  const canSubmit = currentReason?.trim() && !isEmpty(newProduct) && !requesting

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <div>
          {/* Job Service here mean job_service product code  */}
          <h2 className="modal-title">Change Job Service</h2>
        </div>
      </Modal.Header>
      <div className="modal-body px-md-5">
        <form>
          <div className="form-group row">
            <label className="col-3 col-form-label">Current Job Service</label>
            <div className="col-7">
              <input
                disabled
                className="form-control"
                type="text"
                value={label} />
            </div>
          </div>
          <div className="form-group row">
            <label className="col-3 col-form-label">New Job Service*</label>
            <div className="col-7">
              <Select
                name="jobServices"
                isClearable
                isSearchable
                disabled={requesting}
                onChange={e => setNewProduct(e)}
                options={productCodeOptions}
                placeholder="Select a Job Service"
                value={newProduct} />
            </div>
          </div>
          <div className="form-group row">
            <label className="col-3 col-form-label">Reason for Change*</label>
            <div className="col-7">
              <input
                type="text"
                disabled={requesting}
                className="form-control"
                onChange={e => setCurrentReason(e.target.value)}
                value={currentReason} />
            </div>
          </div>
        </form>
        <hr />
      </div>
      <div className="modal-footer">
        <button
          className="btn btn-primary btn-lg"
          onClick={() => setShowConfirmation(true)}
          disabled={!canSubmit}
          type="submit">
          Save
          {requesting && <Spinner className="ml-1" animation="border" role="status" size="sm" />}
        </button>
      </div>

      <SweetAlert
        show={showConfirmation}
        type="info"
        title="Are you sure?"
        closeOnClickOutside
        allowEscape={false}
        showCloseButton
        onCancel={() => setShowConfirmation(false)}
        confirmBtnText="Update"
        onConfirm={onConfirm}>
        <span>Job service will change to</span>
        <span className="ml-1"><strong>{newProduct?.label}</strong></span>
        <span className="ml-1">with Reason:</span>
        <br />
        <br />
        <strong>{currentReason}</strong>
      </SweetAlert>
    </Modal>
  )
}

export default UpdateJobServiceCodeModal